/**
 * CoA helpers shared by the genealogy screens (Batch Genealogy page, LineageGraph, FullTraceCard).
 *
 * stateForCoa — the indicator state for a lot's CoA, from the server's own status word through
 *   stateForStatus (approved → ok, rejected → error, anything else → neutral). No CoA on record is an error.
 * coaResult — one CoA test result as text. The server stores either a plain value or
 *   {value, unit, result, specification}; any other shape falls back to compact JSON, so an object
 *   never renders as "[object Object]".
 */
import { stateForStatus } from './StatusIndicator';

export const stateForCoa = (coa) => (coa ? stateForStatus(coa.status) : 'error');

const compact = (x) => {
  try {
    return JSON.stringify(x);
  } catch (e) {
    return String(x);
  }
};
const part = (x) => (x === null || x === undefined || x === '' ? '' : typeof x === 'object' ? compact(x) : String(x));

export const coaResult = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v !== 'object') return String(v);
  if (Array.isArray(v) || !['value', 'unit', 'result', 'specification'].some((k) => k in v)) return compact(v);
  const val = v.value !== null && v.value !== undefined ? `${part(v.value)}${v.unit ? ` ${part(v.unit)}` : ''}` : '';
  return [val, part(v.result), v.specification !== null && v.specification !== undefined ? `spec ${part(v.specification)}` : ''].filter(Boolean).join(' · ') || compact(v);
};
